import { Loader2 } from 'lucide-react';

import { ExportStatusBadge } from './ExportStatus';

import { Badge } from '@/components/ui/Badge';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/Card';
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from '@/components/ui/Table';
import { useGetVoiceToneExports } from '@/hooks/useGetVoiceToneExports';

export function ExportList() {
  const { exports, isLoading } = useGetVoiceToneExports();

  if (isLoading) {
    return (
      <Card>
        <CardHeader>
          <CardTitle>Voice Tone Exports</CardTitle>
        </CardHeader>
        <CardContent className="flex items-center justify-center py-8">
          <Loader2 className="size-6 animate-spin text-muted-foreground" />
        </CardContent>
      </Card>
    );
  }

  if (exports.length === 0) {
    return (
      <Card>
        <CardHeader>
          <CardTitle>Voice Tone Exports</CardTitle>
        </CardHeader>
        <CardContent className="py-8 text-center">
          <p className="text-sm text-muted-foreground">
            No exports created yet. Create your first export above.
          </p>
        </CardContent>
      </Card>
    );
  }

  return (
    <Card>
      <CardHeader>
        <CardTitle>Voice Tone Exports</CardTitle>
      </CardHeader>
      <CardContent>
        <div className="overflow-x-auto">
          <Table>
            <TableHeader>
              <TableRow>
                <TableHead>Job ID</TableHead>
                <TableHead>Customer ID</TableHead>
                <TableHead>Prompt</TableHead>
                <TableHead>Version</TableHead>
                <TableHead>Created At</TableHead>
                <TableHead>Status</TableHead>
                <TableHead>Error Message</TableHead>
                <TableHead>File URL</TableHead>
              </TableRow>
            </TableHeader>
            <TableBody>
              {exports.map((exp) => (
                <TableRow key={exp.jobId}>
                  <TableCell className="font-mono text-sm">
                    {exp.jobId}
                  </TableCell>
                  <TableCell>{exp.customerId}</TableCell>
                  <TableCell className="font-medium">
                    {exp.promptName}
                  </TableCell>
                  <TableCell className="text-muted-foreground">
                    {exp.version}
                  </TableCell>
                  <TableCell className="text-sm text-muted-foreground">
                    {new Date(exp.createdAt).toLocaleDateString('en-US', {
                      day: '2-digit',
                      month: 'short',
                      year: 'numeric',
                      hour: '2-digit',
                      minute: '2-digit',
                    })}
                  </TableCell>
                  <TableCell>
                    <ExportStatusBadge status={exp.status} />
                  </TableCell>
                  <TableCell className="max-w-[200px] truncate text-sm text-muted-foreground">
                    <Badge variant={exp.error ? 'destructive' : 'outline'}>
                      {exp.error || '-'}
                    </Badge>
                  </TableCell>
                  <TableCell className="max-w-[200px] truncate text-sm text-muted-foreground">
                    {exp.fileUrl ? (
                      <a
                        href={exp.fileUrl}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="text-blue-600 hover:underline"
                      >
                        Download
                      </a>
                    ) : (
                      '-'
                    )}
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </div>
      </CardContent>
    </Card>
  );
}
